<div class="tabbable__panel panel-margin right section info clearfix">
  <div class="col-sm-12 padding-left-right--2x">
    <h2>OMS lager</h2>
    <p class="text--thin text--black">
      Förfrågningar som skickats till OMS vid bokning och uppdatering av kampanjen.
    </p>
  </div>
</div>

<div class="tabbable__body clearfix">
  <dot-loader [visibility]="state().status === 'loading'" description="Hämtar OMS-förfrågningar"></dot-loader>

  @if (state().status === 'error') {
    <p>Kunde inte hämta OMS-förfrågningar. Försök igen senare.</p>
  }

  @if (state().status === 'success') {
    @if (state().data.length === 0) {
      <p class="text--thin">Inga OMS-förfrågningar har skickats för den här kampanjen.</p>
    } @else {
      <app-woo-table [data]="state().data" [expandable]="true" [fixedLayout]="true" [expandedTpl]="detailTpl">
        <woo-table-column name="created_at" header="Datum">
          <ng-template let-cell>{{ cell.value | date : 'yyyy-MM-dd HH:mm:ss' }}</ng-template>
        </woo-table-column>
        <woo-table-column name="event" header="Händelse">
          <ng-template let-cell>{{ eventText(cell.value) }}</ng-template>
        </woo-table-column>
        <woo-table-column name="verdict" header="OMS">
          <ng-template let-cell>
            <span [ngClass]="verdictClass(cell.value)">{{ verdictText(cell.value) }}</span>
          </ng-template>
        </woo-table-column>
        <woo-table-column name="woo_verdict" header="WOO">
          <ng-template let-cell>
            <span [ngClass]="wooVerdictClass(cell.value)">{{ wooVerdictText(cell.value) }}</span>
          </ng-template>
        </woo-table-column>
        <woo-table-column name="woo_overbooked" header="Överbokad">
          <ng-template let-cell>
            @if (cell.value === true) {
              <span class="text--warning">Ja</span>
            } @else if (cell.value === false) {
              Nej
            } @else {
              –
            }
          </ng-template>
        </woo-table-column>
      </app-woo-table>

      <ng-template #detailTpl let-data>
        @for (entry of data.row.requests ?? []; track $index) {
          <div class="margin-bottom--2x">
            <h4 style="font-size: 1.25rem">
              {{ targetingLabel(entry) }}
              @if (entry.region_name) {
                — {{ entry.region_name }}
              } @else if (entry.request.targeting.regions?.length) {
                — {{ entry.request.targeting.regions.join(', ') }}
              }
            </h4>
            @if (targetingInfo(entry)) {
              <p class="text--thin">{{ targetingInfo(entry) }}</p>
            }

            <h5 style="font-size: 1.05rem">OMS</h5>
            <table class="table table--hover with-seperator table--layout--fixed">
              <colgroup>
                <col style="width: 25%" />
                <col style="width: 15%" />
                <col style="width: 60%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">Period</th>
                  <th scope="col">Längd (s)</th>
                  <th scope="col">Begärda kontakter</th>
                </tr>
              </thead>
              <tbody>
                @for (placement of entry.request.placements; track $index) {
                  <tr>
                    <td>{{ placement.startDate }} – {{ placement.endDate }}</td>
                    <td>{{ placement.creativeLength }}</td>
                    <td>{{ placement.requestedContacts | number }}</td>
                  </tr>
                }
              </tbody>
            </table>
            @if (entry.response) {
              <table class="table table--hover with-seperator table--layout--fixed">
                <colgroup>
                  <col style="width: 40%" />
                  <col style="width: 60%" />
                </colgroup>
                <tbody>
                  <tr>
                    <td class="text--thin">Bokningsbart enligt OMS</td>
                    <td>{{ entry.response.bookable ? 'Ja' : 'Nej' }}</td>
                  </tr>
                  @if (entry.response.bookableContacts != null) {
                    <tr>
                      <td class="text--thin">Bokningsbara kontakter</td>
                      <td>{{ entry.response.bookableContacts | number }}</td>
                    </tr>
                  }
                  @if (entry.response.reason) {
                    <tr>
                      <td class="text--thin">Anledning</td>
                      <td>{{ entry.response.reason }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p class="text--warning">Inget svar från OMS.</p>
            }

            <h5 style="font-size: 1.05rem">WOO</h5>
            @if (entry.woo) {
              <table class="table table--hover with-seperator table--layout--fixed">
                <colgroup>
                  <col style="width: 40%" />
                  <col style="width: 60%" />
                </colgroup>
                <tbody>
                  @for (field of wooFigureFields; track field.key) {
                    @if (entry.woo[field.key] != null) {
                      <tr>
                        <td class="text--thin">{{ wooFigureLabel(field, entry.woo) }}</td>
                        <td>{{ entry.woo[field.key] | number }}</td>
                      </tr>
                    }
                  }
                  @if (entry.woo.strategy) {
                    <tr>
                      <td class="text--thin">Strategi</td>
                      <td>{{ strategyText(entry.woo.strategy) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p class="text--thin">WOO-siffror saknas för den här posten.</p>
            }

            <details class="margin-top--1x">
              <summary class="clickable-link">
                <h5 class="margin-bottom--none" style="display: inline">Skickad förfrågan (JSON)</h5>
              </summary>
              <woo-code [indent]="'small'">{{ entry.request | json }}</woo-code>
            </details>
          </div>
        }
      </ng-template>
    }
  }
</div>
